const indexes = [
  {
    id: 1, title: '娱乐圈大瓜', count: '128篇', desc: '明星动态、恋情曝光、综艺风波',
    icon: 'ri-star-line', color: 'bg-primary-100 text-primary-600',
  },
  {
    id: 2, title: '网红圈吃瓜', count: '96篇', desc: '短视频达人、直播事件、翻车现场',
    icon: 'ri-live-line', color: 'bg-accent-100 text-accent-700',
  },
  {
    id: 3, title: '社会热点', count: '84篇', desc: '民生话题、争议事件、深度追踪',
    icon: 'ri-earth-line', color: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 4, title: '综艺吐槽', count: '73篇', desc: '节目点评、名场面、神操作合集',
    icon: 'ri-tv-line', color: 'bg-primary-100 text-primary-600',
  },
  {
    id: 5, title: '电竞风云', count: '61篇', desc: '赛事热点、选手八卦、圈内趣闻',
    icon: 'ri-gamepad-line', color: 'bg-accent-100 text-accent-700',
  },
  {
    id: 6, title: '影视点评', count: '55篇', desc: '新片评测、翻车神作、隐藏好片',
    icon: 'ri-film-line', color: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 7, title: '每日必吃', count: '42篇', desc: '今日必看精选，不容错过的重磅大瓜',
    icon: 'ri-fire-line', color: 'bg-primary-100 text-primary-600',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            📋 大瓜合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按主题分类浏览，快速找到你感兴趣的大瓜专区
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexes.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group block p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg ${item.color} flex items-center justify-center mb-3`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-800 group-hover:text-primary-600 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{item.count}</span>
              <p className="text-xs text-foreground-400 mt-2 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}